import React from "react";
import _extendLayout from "../layout/_extendLayout";
import MachinePerformance from "../components/MachinePerformance";
import { useAuth } from "../auth/AuthProvider";
import { ACCESS } from "../components/constant";

import "../components/css/Dashboard.css";


const DashboardPage = () => {
    const { can, userDetails } = useAuth();
    const hasDashboardAccess = can(ACCESS.DASHBOARD);

    return (
        <>
            <_extendLayout>
                {hasDashboardAccess ? (
                    <MachinePerformance />
                ) : (
                    <div style={{ textAlign: "center", paddingTop: "3rem" }}>
                        <p>Welcome to your Dashboard!</p>
                        <h3>{userDetails?.firstName || "-"}</h3>
                        <p>{userDetails?.email || "-"}</p>
                    </div>
                )}
            </_extendLayout>
        </>
    )
};

export default DashboardPage;